import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { DriverLoginLogout } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class DriverAttendanceDetailsService extends BaseGetProvider<DriverLoginLogout> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof DriverLoginLogout {
    return DriverLoginLogout;
  }

  get endpoint(): string {
    return this.endpointService.driverAttendance();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(
    driverId: number,
  ): {
    driver_id: number;
  } {
    const params: {
      driver_id: number;
    } = {
      driver_id: driverId,
    };

    return params;
  }
}
